import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { XMEDICAL_CORE_PIPE_IMPORTS } from './pipes.imports';

@NgModule({
  imports: [
    CommonModule,
    ...XMEDICAL_CORE_PIPE_IMPORTS
  ],
  exports: [
    ...XMEDICAL_CORE_PIPE_IMPORTS
  ]
})
export class PipesModule { }
